import { render, staticRenderFns } from "./Readmore.vue?vue&type=template&id=2475ada2&"
import script from "./Readmore.vue?vue&type=script&lang=js&"
export * from "./Readmore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports